import './utils/tooltips'
import './utils/toggles'
import './utils/tabs'
// import './utils/darkmode'
import './utils/wcag'
import './utils/smooth-scroll'
import './utils/load-more'
import './utils/modal'
import './utils/animate'
import './utils/floating-cta'
import './utils/popup'
import './menu/menu'
import './page-components/testimonials'
import './utils/gravity-form-inputs'
import '../../inc/acf/lightning-builder/page-components/pc-timeline/js/timeline'
import '../../inc/acf/lightning-builder/page-components/pc-post-listing/js/filters'
import '../../inc/acf/lightning-builder/page-components/pc-logo-banner/js/pc-logo-banner'
import '../../inc/acf/lightning-builder/page-components/pc-testimonials/js/pc-testimonials'
import '../../inc/acf/lightning-builder/page-components/pc-highlights/js/pc-highlights'
import '../../inc/acf/lightning-builder/page-components/pc-offerings/js/pc-offerings'
import '../../inc/acf/lightning-builder/page-components/pc-animate-numbers/js/pc-animate-numbers'

// scss
import '../scss/style.scss'
import 'aos/dist/aos.css';

if (module.hot) {
    module.hot.accept()
}

import AOS from 'aos';

AOS.init({
    offset: 0, // minska påverkan på layout
});

